module.exports = __webpack_public_path__ + "static/media/logov1-only.4afaa6c9.jpg";